import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";

const getDefaultState = () => {
  return {
    isNextForStep1: false, // createMotpStep1 다음버튼
    nextRoutName: "main", // 발급 완료 후 이동할 route name(default: main)
    dailyminMaxInfo: {
      ogvtn: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+500,000K", amt: "500000000" },
          { view: "+100,000K", amt: "100000000" },
        ],
      },
      ogcbd: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+100,000", amt: "100000" },
          { view: "+50,000", amt: "50000" },
        ],
      },
      ogauc: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+100,000", amt: "100000" },
          { view: "+50,000", amt: "50000" },
        ],
      },
      ogmmr: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+100,000", amt: "100000" },
          { view: "+50,000", amt: "50000" },
        ],
      },
    },
    casPerminMaxInfo: {
      ogvtn: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+100,000K", amt: "100000000" },
          { view: "+50,000K", amt: "50000000" },
          { view: "+10,000K", amt: "10000000" },
        ],
      },
      ogcbd: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+5,000", amt: "5000" },
          { view: "+1,000", amt: "1000" },
        ],
      },
      ogauc: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+100,000", amt: "100000" },
          { view: "+50,000", amt: "50000" },
        ],
      },
      ogmmr: {
        simpleBtnArr: [
          { view: "MAX", amt: "0" },
          { view: "+100,000", amt: "100000" },
          { view: "+50,000", amt: "50000" },
        ],
      },
    },
    /**
     * mOTP 발급 init
     */
    initMotp: {
      in: {},
      out: {
        success: {
          mOtpId: "", // mOTP iD
          systemId: "", // mOTP systemId
          outItem: {
            ppsnCoprDstcd: "", // 개인법인구분코드
            cncycd: "", // 통화코드
            dailyTrsaccClam: 0, // 일일이체한도금액
            casPerTrsaccClam: 0, // 건별이체한도금액
          },
          mOtpInfo: {
            operGroupCd: "",
            iD: "",
            otpStusDstcd: "",
            coprPpsnDstcd: "",
            cin: "",
            wWWBnkgLginID: "",
            mchtlUniqNo: "",
            pinFailNotms: 0,
            certnErrNotms: 0,
            totalCertnSucssNotms: 0,
            totalCertnErrNotms: 0,
            frstCertnSucssLcalYMS: "",
            lastCertnDmndLcalYMS: "",
            lastCertnSucssLcalYMS: "",
            lastCertnErrLcalYMS: "",
            issuncLcalYMS: "",
            frstCertnSucssYMS: "",
            lastCertnDmndYMS: "",
            lastCertnSucssYMS: "",
            lastCertnErrYMS: "",
            issuncYMS: "",
            smphMchtlUniqNo: "",
            smphMchtlDstcd: "",
            pgmVsnno: "",
            certnDmndCd: "",
            smphMdelName: "",
            writYMS: "",
            lastAmndYMS: "",
            rmark: "",
            id: "",
            wwwbnkgLginID: "",
          },
        },
        fail: {},
      },
    },
    /**
     * mOTP 기기정보
     */
    SSInfogetMotp: {
      in: {},
      out: [
        // {
        // 	strUserId: "G21000009100000"
        // , secret: "dfefewfsdfadsafasdfasdfsdf...."
        // }
      ],
    },
    /**
     * 고객정보조회
     */
    RBF0409E40: {
      in: {},
      out: {
        success: {
          cphnNo: "", // 휴대폰 번호
          emad1: "", // 이메일 주소
          celNomalSendzYn: "", // 휴대전화정상송신여부(0/1) 휴대전화번호를 고객이 검증했는지 여부
          celRecvCnsntYn: "", // 휴대전화수신동의여부(0/1) 휴대전화 문자수신 동의 여부
          emailNomalSendzYn: "", // 이메일정상송신여부(0/1) 이메일주소를 고객이 검증했는지 여부
          emailRecvCnsntYn: "", // 이메일수신동의여부(0/1) 이메일 문자수신 동의 여부
          certnNatnlCd: "", // 인증국가코드
          certnCphnNo: "", // 인증국가코드
          otpUniqIdnfiNo: "", // 보안장치고유식별번호
          scurtyDeviVndrDstcd: "", // 보안장치벤더구분코드
          smsUseYn: "", //SMS사용여부
          smsCnptList: [], //SMS연락처리스트
        },
        fail: {},
      },
    },
    /**
     * SMS연락처리스트 for select box
     */
    smsCnptList: [],

    /**
     * 은행기본이체한도조회
     */
    RBF0402N40: {
      in: {},
      out: {
        success: {
          ppsnCoprDstcd: "", // 개인법인구분코드
          cncycd: "", // 통화코드
          dailyTrsaccClam: 0, // 일일이체한도금액
          casPerTrsaccClam: 0, // 건별이체한도금액
        },
        fail: {},
      },
    },
    /**
     * 이체한도 & 입력방법 설정
     */
    trsaccClam: {
      in: {
        dailyTrsaccClam: "", // 일일이체한도
        casPerTrsaccClam: "", // 건별이체한도금액
        certnDmndCd: "1", // 인증요청코드(1:자동, 2:수동)
      },
      out: {
        success: {
          trsaccClamResult: "",
        },
        fail: {},
      },
    },
    /**
     * mPIN 번호의 보안유효성 검사
     */
    checkMpin: {
      in: {
        mPin01: "",
        mPin02: "",
      },
      out: {
        success: {
          rsultCd: "",
          equalResult: "",
        },
        fail: {},
      },
    },
    /**
     * mOTP 등록
     */
    SSRegisterMotpPin: {
      in: {
        result: "",
        publickey: "",
        userdata: "",
        errorcode: "",
        smphMchtlUniqNo: "", // 스마트폰기기고유번호
        smphMchtlDstcd: "", // 스마트폰기기구분코드(1:IPhone, 2:안드로이드)
        pgmVsnno: "", // 프로그램버전번호
        smphMdelName: "", // 스마트폰모델명
      },
      out: {
        success: {
          RESULT: "",
          MOTPINFO: "",
          SKEY: "",
          ERRORCODE: "",
        },
        fail: {},
      },
    },
    /**
     * mOTP 발급완료
     */
    finishMotp: {
      in: {
        result: "",
        secret: "",
        errorcode: "",
      },
      out: {
        success: {
          dailyTrsaccClam: "", // 일일이체한도
          casPerTrsaccClam: "", // 건별이체한도금액
          certnDmndCd: "", // 인증요청코드(1:자동, 2:수동)
          scurtyDeviVndrDstcd: "", // 보안장치벤더구분코드
        },
        fail: {},
      },
    },
  };
};

const createMotp = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getSSInfogetMotp: state => {
      return state.SSInfogetMotp;
    },
    getRBF0409E40: state => {
      return state.RBF0409E40;
    },
    getSMSCnptList: state => {
      return state.smsCnptList;
    },
    getTrsaccClam: state => {
      return state.trsaccClam;
    },
    getCheckMpin: state => {
      return state.checkMpin;
    },
    getSSRegisterMotpPin: state => {
      return state.SSRegisterMotpPin;
    },
    getInitMotp: state => {
      return state.initMotp;
    },
    getFinishMotp: state => {
      return state.finishMotp;
    },
    getRBF0402N40: state => {
      return state.RBF0402N40;
    },
    getNextRoutName: state => {
      return state.nextRoutName;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut001: function (state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },
    mut006: function (state, payload) {
      const org = state.trsaccClam.in[payload.key];
      this._vm.$set(state.trsaccClam.in, payload.key, " ");
      payload.value = this._vm.$removeComma(String(payload.value));
      if (isNaN(payload.value)) {
        this._vm.$set(state.trsaccClam.in, payload.key, org);
        return;
      }
      payload.value = Number(payload.value);
      if (payload.key === "dailyTrsaccClam") {
        if (Number(payload.value) > Number(state.RBF0402N40.out.success.dailyTrsaccClam)) {
          payload.value = state.RBF0402N40.out.success.dailyTrsaccClam;
        }
      }
      if (payload.key === "casPerTrsaccClam") {
        if (Number(payload.value) > Number(state.RBF0402N40.out.success.casPerTrsaccClam)) {
          payload.value = state.RBF0402N40.out.success.casPerTrsaccClam;
        }
      }
      this._vm.$set(state.trsaccClam.in, payload.key, payload.value);
    },
    mut007: function (state, payload) {
      this._vm.$set(state.checkMpin.in, payload.key, payload.value);
    },
    mut008: function (state, payload) {
      this._vm.$set(state.SSRegisterMotpPin.in, payload.key, payload.value);
    },
    mut009: function (state, payload) {
      this._vm.$set(state.finishMotp.in, payload.key, payload.value);
    },
    mut011: state => {
      Object.assign(state.checkMpin, getDefaultState().checkMpin);
    },
    mut012: function (state, payload) {
      this._vm.$set(state.RBF0402N40.out.success, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * 고객정보조회 + OTP 번호 조회
     */
    act002: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/issunc/RBF0409E40",
          context.state.RBF0409E40.in,
          response => {
            this._vm.$set(this.state.auth.createMotp.RBF0409E40.out, "success", response);
            this.state.auth.createMotp.smsCnptList = getDefaultState().smsCnptList;
            //SMS연락처
            for (let i = 0; i < this.state.auth.createMotp.RBF0409E40.out.success.smsCnptList.length; i++) {
              let temp = { text: "", value: "", data: {} };
              let ovsesSMSBzwkDstcd = this.state.auth.createMotp.RBF0409E40.out.success.smsCnptList[i].ovsesSMSBzwkDstcd;
              let cntpSerno = this.state.auth.createMotp.RBF0409E40.out.success.smsCnptList[i].cntpSerno;
              let brncoIntnTelDstcd = this.state.auth.createMotp.RBF0409E40.out.success.smsCnptList[i].brncoIntnTelDstcd;
              let cntpCtnt = this.state.auth.createMotp.RBF0409E40.out.success.smsCnptList[i].cntpCtnt;
              let recvCnsntYn = this.state.auth.createMotp.RBF0409E40.out.success.smsCnptList[i].recvCnsntYn;              

              if (_.isNil(brncoIntnTelDstcd) || _.isEmpty(brncoIntnTelDstcd) || recvCnsntYn != "1") {
                temp.text = "+() " + cntpCtnt.slice(cntpCtnt.length * -1, cntpCtnt.length - 8) + "**"
                  + cntpCtnt.slice(-6, cntpCtnt.length - 4) + "**"
                  + cntpCtnt.slice(-2, cntpCtnt.length);
              } else {
                temp.text = "+(" + brncoIntnTelDstcd + ") " + cntpCtnt;
              }
              temp.value = cntpCtnt;
              temp.data.ovsesSMSBzwkDstcd = ovsesSMSBzwkDstcd;
              temp.data.cntpSerno = cntpSerno;
              temp.data.brncoIntnTelDstcd = brncoIntnTelDstcd;
              temp.data.cntpCtnt = cntpCtnt;
              temp.data.recvCnsntYn = recvCnsntYn;
              this.state.auth.createMotp.smsCnptList.push(temp);
            }
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.createMotp.RBF0409E40.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 이체한도 & 입력방법 설정
     */
    act008: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/issunc/trsaccClam",
          context.state.trsaccClam.in,
          response => {
            this._vm.$set(this.state.auth.createMotp.trsaccClam.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.createMotp.trsaccClam.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mPIN 번호의 보안유효성 && 동일성 검사
     */
    act009: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/issunc/checkMpin",
          this.state.auth.createMotp.checkMpin.in,
          response => {
            // 첫번째 입력. 성공
            if (this.state.auth.createMotp.checkMpin.in.mPin01 !== "" && this.state.auth.createMotp.checkMpin.in.mPin02 === "") {
              // [native] keypad 2번째 입력한다.
              context.dispatch("act010", "openKeypadForMotpReg2");
            }

            // 두번째 입력. 성공.
            if (this.state.auth.createMotp.checkMpin.in.mPin01 !== "" && this.state.auth.createMotp.checkMpin.in.mPin02 !== "") {
              // [native] SSRegisterMotpPin 호출!!
              context.dispatch("act010", "SSRegisterMotpPin");
            }

            this._vm.$set(this.state.auth.createMotp.checkMpin.out, "success", response);
            resolve("success");
          },
          response => {
            // 첫번째 입력. 실패
            if (this.state.auth.createMotp.checkMpin.in.mPin01 !== "" && this.state.auth.createMotp.checkMpin.in.mPin02 === "") {
              context.commit("mut007", { key: "mPin01", value: "" });
            }

            // 두번째 입력. 실패
            if (this.state.auth.createMotp.checkMpin.in.mPin01 !== "" && this.state.auth.createMotp.checkMpin.in.mPin02 !== "") {
              context.commit("mut007", { key: "mPin02", value: "" });
            }

            this._vm.$set(this.state.auth.createMotp.checkMpin.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * native bridge call
     */
    act010: function (context, payload) {
      switch (payload) {
        case "openKeypadForMotpReg2":
          this._vm.$bridge.openKeypadForMotpReg2();
          break;
        case "SSRegisterMotpPin":
          this._vm.$bridge.SSRegisterMotpPin(this.state.auth.createMotp.initMotp.out.success.mOtpId, this.state.auth.createMotp.initMotp.out.success.systemId);
          break;
        case "SSInitializeMotp":
          this._vm.$bridge.SSInitializeMotp({
            strUserId: this.state.auth.createMotp.initMotp.out.success.mOtpId,
            strSystemId: this.state.auth.createMotp.initMotp.out.success.systemId,
            strMotpInfo: this.state.auth.createMotp.SSRegisterMotpPin.out.success.MOTPINFO,
            strSKey: this.state.auth.createMotp.SSRegisterMotpPin.out.success.SKEY,
          });
          break;
      }
    },
    /**
     * mOTP 등록
     */
    act011: function (context) {
      return new Promise(resolve => {
        this.state.auth.createMotp.SSRegisterMotpPin.in.smphMchtlUniqNo = this.state.native.smphMchtlUniqNo;
        this.state.auth.createMotp.SSRegisterMotpPin.in.smphMchtlDstcd = this.state.native.smphMchtlDstcd;
        this.state.auth.createMotp.SSRegisterMotpPin.in.pgmVsnno = this.state.native.pgmVsnno;
        this.state.auth.createMotp.SSRegisterMotpPin.in.smphMdelName = this.state.native.smphMdelName;

        this._vm.$post(
          "/auth/motp/issunc/SSRegisterMotpPin",
          this.state.auth.createMotp.SSRegisterMotpPin.in,
          response => {
            // [native] SSInitializeMotp 호출!!
            this._vm.$set(this.state.auth.createMotp.SSRegisterMotpPin.out, "success", response);
            context.dispatch("act010", "SSInitializeMotp");
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.createMotp.SSRegisterMotpPin.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mOTP 등록 init
     */
    act012: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/issunc/initMotp",
          this.state.auth.createMotp.initMotp.in,
          response => {
            this._vm.$set(this.state.auth.createMotp.initMotp.out.success, "systemId", response.systemId);
            this._vm.$set(this.state.auth.createMotp.initMotp.out.success, "mOtpId", response.mOtpId);
            // 은행이체한도set
            for (const k in response.outItem) {
              context.commit("mut012", { key: k, value: response.outItem[k] });
            }
            context.state.dailyminMaxInfo[this.state.siteCode].simpleBtnArr.forEach(e => {
              if (e.view === "MAX") {
                e.amt = response.outItem.dailyTrsaccClam;
              }
            });
            context.state.casPerminMaxInfo[this.state.siteCode].simpleBtnArr.forEach(e => {
              if (e.view === "MAX") {
                e.amt = response.outItem.casPerTrsaccClam;
              }
            });
            // mOtpInfo
            this._vm.$set(this.state.auth.createMotp.initMotp.out.success, "mOtpInfo", response.mOtpInfo);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.createMotp.initMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mOTP 발급완료 - native 정상완료인 경우만 호출함.
     */
    act013: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/issunc/finishMotp",
          context.state.finishMotp.in,
          response => {
            router.push({ name: "createMotpStep10" });
            this._vm.$set(this.state.auth.createMotp.finishMotp.out, "success", response);
            resolve("success");
            // vuejs 세션정보 업데이트..
            this.state.sessionInfo.userInfo.scurtyDeviVndrDstcd = response.scurtyDeviVndrDstcd;
          },
          response => {
            this._vm.$set(this.state.auth.createMotp.finishMotp.out, "fail", response);
            // MCI거래 에러시..메인으로..중간 데이터 변경이 필요할수도 있으므로..

            resolve("fail");
          },
        );
      });
    },
    /**
     * 발급시 기기정보 후 처리
     */
    act014: function () {
      // 이미 정상인 mOTP가 있는 경우.
      if (this.state.auth.createMotp.initMotp.out.success.mOtpInfo.otpStusDstcd === "030") {
        router.push({ name: "createMotpStep11" });
      } else {
        this.state.auth.createMotp.isNextForStep1 = true;
      }
    },
    /**
     * 3자리마다 콤마
     */
    act015: function (num) {
      var numValue = "" + num;
      numValue = numValue.replace(/,/gi, "");
      var returnVal = "";

      for (var i = numValue.length - 1; i >= 0; i--) {
        returnVal = numValue.charAt(i) + returnVal;
        if (i != 0 && i % 3 == numValue.length % 3) returnVal = "," + returnVal;
      }

      return returnVal;
    },
    /**
     * mPin 등록시 2번째 키패드 이전버튼 클릭시.. 일단 mPin등록 처음부터..
     */
    act016: function (context) {
      context.commit("mut007", { key: "mPin01", value: "" });
      context.commit("mut007", { key: "mPin02", value: "" });
    },

  },
};

export default createMotp;

/**
 	ErrmsgErrcd: "",
	OutptLangDstcd: "",
	CustGuidLinkURL: "",
	ErrmsgErrSituNo: "",
	CustGuidLinkURLCtnt: "",
	ErrmsgTreatCd: "",
	Clear: "",
	ErrmsgErrPgmName: "",
	Type: "",
	TreatDesc: "",
	Trancode: "",
	ErrmsgOutptCstzMsgCtnt: "",
	MapngDstcd: "",
	Subtype: ""
 */